<template>
  <div  :class="classes">
    <pt-page-title :title="title" :isSearch="true" @search="search" :searchKey="searchKey"  @emptySearch="emptySearch"></pt-page-title>
    <pt-active-sign-table :class="$style['pt-active-sign']" :searchKey="searchKey" :isParseSign="isParseSign" :isQuestionnaire="isQuestionnaire" :tableLabels="tableLabels" :type="typeMessage.type">
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="copyLink(scope.row)" v-clipboard:copy="copyContent(scope.row)" v-clipboard:success="onCopy" v-clipboard:error="onError">复制链接</el-button>
          <!-- <el-button type="text" @click="getDetail(scope.row)">详情</el-button> -->
          <el-button type="text" @click="signList(scope.row)">{{scope.row.type==='QUESTIONNAIRE'?'调查记录':'报名记录'}}</el-button>
        </template>
      </el-table-column>
    </pt-active-sign-table>
  </div>
</template>

<script>
// 组件class前缀
import ptActiveSignTable from './pt-active-sign-table/withData'
import { activeSignTableLabels, parseSignTableLabels, questionSignTableLabels } from './active-sign.js'
const prefixCls = 'pt-active-sign'
export default {
  name: 'pt-active-sign',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    isParseSign () {
      return this.$route.name === 'parse-sign'
    },
    // 调查问卷
    isQuestionnaire () {
      return this.$route.name === 'questionnaire-sign'
    },
    typeMessage () {
      let message = {}
      switch (this.$route.name) {
        case 'questionnaire-sign':
          message.title = '调查问卷'
          message.type = 'QUESTIONNAIRE'
          break
        case 'parse-sign':
          message.title = '报告预约解读'
          message.type = 'PARSE'
          break
        default:
          message.title = '活动报名'
          message.type = 'ACTIVITY'
          break
      }
      return message
    },
    title () {
      return this.typeMessage.title
    },
    tableLabels () {
      return this.isQuestionnaire ? questionSignTableLabels : (this.isParseSign ? parseSignTableLabels : activeSignTableLabels)
    }
  },
  components: {
    ptActiveSignTable
  },
  data () {
    return {
      searchKey: null,
      isLoad: false
    }
  },
  watch: {
    '$route.name' (val) {

    }
  },
  methods: {
    search (val) {
      this.searchKey = val
    },
    emptySearch () {
      this.searchKey = null
    },
    copyLink (row) {

    },
    onCopy () {
      this.$message.success('复制成功，请前往您需要的位置粘贴')
    },
    onError () {
      this.$message.error('复制失败')
    },
    copyContent (row) {
      return '/sign-form?id=' + row.id
    },
    getDetail (row) {},
    signList (row) {
      let link
      switch (row.type) {
        case 'QUESTIONNAIRE':
          link = '/save-sign/question-sign-notes/' + row.name + '/' + row.id
          break
        case 'PARSE':
          link = '/parse-sign/parse-sign-notes/' + row.name + '/' + row.id
          break
        default:
          link = '/save-sign/active-sign-notes/' + row.name + '/' + row.id
          break
      }
      // let link = this.isParseSign ? ('/parse-sign/parse-sign-notes/' + row.name + '/' + row.id) : ('/save-sign/active-sign-notes/' + row.name + '/' + row.id)
      this.$router.push(link)
    }
  },
  created () {

  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-active-sign{
  :global
  .el-button{
    margin-left: 0;
    margin-right: 10px
  }
}
</style>
